module.exports = __webpack_public_path__ + "logo.bd46fd397be0756615db.png";